import request from '@/config/config'
import { Message } from 'element-ui'

// json格式请求头
let headerJSON = {
  'Content-Type': 'application/json'
}

/**
 * Get请求
 * @param {*} url
 * @param {*} params
 * @param {*} showMsg 是否显示成功提示
 * @param {*} getData 是否直接返回data数据
 * @returns
 */
export async function doGet (url, params, showMsg, getData) {
  // console.log('doget request...')
  let uid = getQueryVariable('uid')
  let header = {}
  if (uid) {
    header = { uid: uid }
  }
  try {
    let result = await request({
      url: url,
      method: 'get',
      headers: header,
      params: params
    })
    // console.log(url, result)
    if (result.code === '000000') {
      if (showMsg) {
        Message.success({
          message: result.message,
          type: 'success',
          customClass: 'messageIndex'
        })
      }
      if (getData) {
        return result.data
      } else {
        return result
      }
    } else {
      Message.error({
        message: result.message,
        type: 'error',
        customClass: 'messageIndex'
      })
      return null
    }
  } catch (error) {
    console.log(error)
    return null
  }
}

/**
 * Post请求
 * @param {*} url
 * @param {*} data
 * @param {*} showMsg
 * @param {*} getData 是否直接返回data数据
 * @returns
 */
export async function doPost (url, data, showMsg, getData) {
  let uid = getQueryVariable('uid')
  if (uid) {
    headerJSON = { ...headerJSON, uid: uid }
  }
  try {
    let result = await request({
      url: url,
      method: 'post',
      headers: headerJSON,
      // data: JSON.stringify(data)
      data
    })
    // console.log(result)
    if (result.code === '000000') {
      if (showMsg) {
        Message.success({
          message: result.message,
          type: 'success',
          customClass: 'messageIndex'
        })
      }
      if (getData) {
        return result.data
      } else {
        return result
      }
    } else {
      Message.error({
        message: result.message,
        type: 'error',
        customClass: 'messageIndex'
      })
      return null
    }
  } catch (error) {
    console.log(error)
    // Message.success({
    //   message: error,
    //   type: 'error'
    // })
    return null
  }
}

/**
 * Post导出请求
 * @param {*} url
 * @param {*} data
 * @param {*} showMsg
 * @param {*} getData 是否直接返回data数据
 * @returns
 */
export async function doExport (url, data) {
  let uid = getQueryVariable('uid')
  if (uid) {
    headerJSON = { ...headerJSON, uid: uid }
  }
  try {
    let result = await request({
      url: url,
      method: 'post',
      headers: headerJSON,
      responseType: 'blob',
      // data: JSON.stringify(data)
      data
    })
    return result
  } catch (error) {
    console.log(error)
    // Message.success({
    //   message: error,
    //   type: 'error'
    // })
    return null
  }
}

/**
 * get导出请求
 * @param {*} url
 * @param {*} data
 * @param {*} showMsg
 * @param {*} getData 是否直接返回data数据
 * @returns
 */
export async function doExport2 (url, params) {
  let uid = getQueryVariable('uid')
  let header = {}
  if (uid) {
    header = { uid: uid }
  }
  try {
    let result = await request({
      url: url,
      method: 'get',
      headers: header,
      responseType: 'blob',
      params: params
    })
    return result
  } catch (error) {
    console.log(error)
    // Message.success({
    //   message: error,
    //   type: 'error'
    // })
    return null
  }
}

function getQueryVariable (variable) {
  let url = location.href
  let query = url.substring(url.indexOf('?') + 1, url.length)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] == variable) { return pair[1] }
  }
  return (false)
}
